import { Factory } from './Factory'
import Menu from '../EditorComponents/PricingTable/Menu'

export class PricingTableFactory extends Factory {
	constructor(qty = 1) {
		super()
		this.qty = qty
	}

	object() {
		return {
			id: this.id('pricing-table'),
			featuredId: this.id('pricing-table-featured'),
			priceId: this.id('pricing-table-price'),
			descriptionId: this.id('pricing-table-description'),
			titleId: this.id('pricing-table-title'),
			buttonId: this.id('pricing-table-button'),
			listId: this.id('pricing-table-list'),
			headerId: this.id('pricing-table-header'),
			contentId: this.id('pricing-table-content'),
			footerId: this.id('pricing-table-footer'),
			slug: 'editor-pricing-table',
			assets: {
				phone: [],
				tablet: [],
				desktop: []
			},
			background: {
				phone: 'color',
				tablet: 'color',
				desktop: 'color'
			},
			customClasses: [],
			constantClasses: {
				phone: [],
				tablet: [],
				desktop: []
			},
			containerClasses: {
				phone: [],
				tablet: [],
				desktop: []
			},
			name: 'PricingTable',
		}
	}

	properties() {
		return {
			content: [
        {key: 'isFeatured', component: 'ContentToggle', text:'Featured', property: 'featured'},
        {key: 'hasTitle', component: 'ContentToggle', text:'Title', property: 'hasTitle'},
        {key: 'hasDescription', component: 'ContentToggle', text:'Description', property: 'hasDescription'},
        {key: 'hasList', component: 'ContentToggle', text:'List', property: 'hasList'},
        {key: 'icon-content', component:'ContentIcon'},
        {key: 'recurrency-type', component: 'ContentSelect', text: 'Recurrency', property: 'recurrency', items: this.recurrencyTypes()},
        {key: 'button-link', component:'ContentText', text: 'Button link', property: 'buttonLink'},
			],
			styles: [
				{key: 'rounded', component:'RoundedProperty'},
        {key: 'shadow', component:'ShadowProperty'},
        {key: 'border', component:'BorderProperty'},
        {key: 'margin', component:'MarginProperty'},
			],
			featuredStyles: [
				{key: 'width', component:'WidthProperty', class:'featuredClasses'},
				{key: 'text-alignment', component: 'TextAlignmentProperty', class:'featuredContainerClasses'},
				{key: 'background-color', component:'BackgroundProperty', only: ['color'], class:'featuredClasses', styles: 'featuredStyles'},
				{key: 'color', component:'TextColorProperty', styles: 'featuredStyles'},
				{key: 'font-size', component: 'FontSizeProperty', class:'featuredClasses'},
				{key: 'font-weight', component: 'FontWeightProperty', class:'featuredClasses'},
				{key: 'rounded', component:'RoundedProperty', class:'featuredClasses'},
				{key: 'shadow', component:'ShadowProperty', class:'featuredClasses'},
				{key: 'padding', component:'PaddingProperty', class:'featuredClasses'},
				{key: 'margin', component:'MarginProperty', class:'featuredContainerClasses'},
				{key: 'border', component:'BorderProperty', class:'featuredClasses', styles: 'featuredStyles'},
			],
			headerStyles: [
				{key: 'background-color', component:'BackgroundProperty', only: ['color'], class:'headerClasses', styles: 'headerStyles'},
				{key: 'padding', component:'PaddingProperty', class:'headerClasses'},
			],
			contentStyles: [
				{key: 'background-color', component:'BackgroundProperty', only: ['color'], class:'contentClasses', styles: 'contentStyles'},
				{key: 'padding', component:'PaddingProperty', class:'contentClasses'},
				{key: 'border', component:'BorderProperty', class:'contentClasses', styles: 'contentStyles'},
			],
			footerStyles: [
				{key: 'background-color', component:'BackgroundProperty', only: ['color'], class:'footerClasses', styles: 'footerStyles'},
				{key: 'padding', component:'PaddingProperty', class:'footerClasses'},
			],
			titleStyles: [
				{key: 'text-alignment', component: 'TextAlignmentProperty', class:'titleContainerClasses'},
				{key: 'background-color', component:'BackgroundProperty', only: ['color'], class:'titleClasses', styles: 'titleStyles'},
				{key: 'text-color', component:'TextColorProperty', styles: 'titleStyles'},
				{key: 'font-size', component: 'FontSizeProperty', class:'titleClasses'},
				{key: 'font-weight', component: 'FontWeightProperty', class:'titleClasses'},
				{key: 'rounded', component:'RoundedProperty', class:'titleClasses'},
				{key: 'border', component:'BorderProperty', class:'titleClasses', styles: 'titleStyles'},
			],
			priceStyles: [
				{key: 'text-alignment', component: 'TextAlignmentProperty', class:'priceContainerClasses'},
				{key: 'text-color', component:'TextColorProperty', styles: 'priceStyles'},
				{key: 'font-size', component: 'FontSizeProperty', class:'priceClasses'},
				{key: 'font-weight', component: 'FontWeightProperty', class:'priceClasses'},
			],
			buttonStyles: [
				{key: 'background-color', component:'BackgroundProperty', only: ['color'], class:'buttonClasses', styles: 'buttonStyles'},
				{key: 'text-color', component:'TextColorProperty', styles: 'buttonStyles'},
				{key: 'font-weight', component: 'FontWeightProperty', class:'buttonClasses'},
				{key: 'rounded', component:'RoundedProperty', class:'buttonClasses'},
				{key: 'shadow', component:'ShadowProperty', class:'buttonClasses'},
				{key: 'border', component:'BorderProperty', class:'buttonClasses', styles: 'buttonStyles'},
			],
			descriptionStyles: [
				{key: 'text-alignment', component: 'TextAlignmentProperty', class:'descriptionContainerClasses'},
				{key: 'text-color', component:'TextColorProperty', styles: 'descriptionStyles'},
				{key: 'font-size', component: 'FontSizeProperty', class:'descriptionClasses'},
				{key: 'font-weight', component: 'FontWeightProperty', class:'descriptionClasses'},
			],
			listStyles: [
				{key: 'text-color', component:'TextColorProperty', styles: 'listStyles'},
				{key: 'font-size', component: 'FontSizeProperty', class:'listClasses'},
				{key: 'font-weight', component: 'FontWeightProperty', class:'listClasses'},
				{key: 'icon-color', component:'TextColorProperty', styles: 'iconStyles', text: 'Icon Color'},
				{key: 'icon-size', component: 'FontSizeProperty', class:'iconClasses'},
			],
			advanced: [
				{key: 'element-id', component: 'ElementId'},
        {key: 'custom-classes', component: 'CustomClasses'},
        {key: 'custom-styles', component: 'CustomStyles'},
      ],
      menu: Menu
		}
	}

	recurrencyTypes() {
		return [
			{value: 'weekly', text: 'Weekly'},
			{value: 'monthly', text: 'Monthly'},
			{value: 'yearly', text: 'Yearly'},
		]
	}
}